import React, { useState, useContext, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";

import Hamburger from 'hamburger-react';
import './styles.css';

import juntosLogo from '../../assets/images/juntos-logo2.png';
import profile from '../../assets/icons/profile-white.png';
import logout from '../../assets/icons/logout-white.png';
import exclamation from '../../assets/icons/exclamation.png';
import UserContext from "../../contexts/UserContext";
import arrow from '../../assets/icons/white-right-arrrow.png';
import usePromoAsset from "hooks/usePromoAsset";

function TopBar() {
    const { currentUser, setCurrentUser, currentPromo, currentUserResults } = useContext(UserContext);
    const { hasPendingPrize } = currentUserResults;

    const [menuOpened, setMenuOpened] = useState(false);
    const [routes, setRoutes] = useState([]);

    const navigate = useNavigate();
    const location = useLocation();

    const { asset: promo } = usePromoAsset(currentPromo, 'logo.png');

    const handleMenu = () => {
        setMenuOpened(!menuOpened);
    };

    useEffect(() => {
        if (menuOpened) {
            window.scrollTo({ top: 0, behavior: 'auto' });
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }
    }, [menuOpened]);

    useEffect(() => setMenuOpened(false), [location]);

    useEffect(() => {
        if (!currentPromo || !currentUser) {
            setRoutes([]);
            return;
        }

        const basePath = currentPromo.path;

        setRoutes([
            { route: `/${basePath}/home`, navbar: 'Home' },
            { route: `/${basePath}/resultados`, navbar: 'Resultados', warning: hasPendingPrize },
            { route: `/${basePath}/numeros`, navbar: 'Meus números' },
            { route: `/${basePath}/premios`, navbar: 'Meus prêmios', warning: hasPendingPrize },
            { route: `/${basePath}/promos`, navbar: 'Promoções' },
            { route: `/${basePath}/perfil`, navbar: 'Meu Perfil' },
        ]);
    }, [hasPendingPrize, currentPromo, currentUser])

    const handleLogout = () => {
        document.body.style.overflow = 'auto';
        setCurrentUser(null, null)
        navigate(`/${currentPromo?.path}/login`);
    };

    return (
        <div className="topbar-container">
            <div className="topbar-upper-container">
                <Link className="topbar-logo-container" to={`/${currentPromo?.path}/home`}>
                    <img src={juntosLogo} className="topbar-logo-image" alt="femsa-logo" />
                    {!!promo && <img src={promo} className="topbar-logo-image-promo" alt="promo-logo" />}
                </Link>
                {!!currentUser && <>
                    <div className="topbar-profile-container">
                        <Link className="topbar-profile" to={`/${currentPromo?.path}/perfil`}>
                            <img src={profile} className="topbar-profile-icon" alt="profile-icon" />
                            <p className="topbar-profile-greet">Olá, <span className="topbar-profile-name">{currentUser?.nome?.split(' ')[0]}</span></p>
                        </Link>
                        <img src={logout} className="topbar-profile-icon" alt="logout-icon" onClick={handleLogout} />
                    </div>
                    <div className="topbar-hamburguer" style={{ zIndex: '200' }}>
                        <Hamburger toggled={menuOpened} toggle={handleMenu} color={menuOpened ? 'white' : "#FFFFFF"} />
                    </div>
                </>}
                {!currentUser && <>
                    <div className="topbar-profile-container">
                        <div className="topbar-profile">
                            {currentPromo.status === 'active' && <>
                                <Link className="navbar-signin-container only-mobile"
                                    to={`/${currentPromo?.path}/${window.location.href.includes('signin') ? 'login' : 'signin'}`}>
                                    <p>{window.location.href.includes('signin') ? 'Entrar' : 'Cadastre-se'}</p>
                                </Link>
                                <Link className="navbar-signin-container only-desktop" to={`/${currentPromo?.path}/signin`}>
                                    <p>Cadastre-se</p>
                                </Link>
                            </>}
                            <Link className="navbar-login-container only-desktop" to={`/${currentPromo?.path}/login`}>
                                <p>Entrar</p>
                            </Link>
                        </div>
                    </div>
                </>}
            </div>
            {!!routes.length && <>
                <div className="topbar-nav-container notranslate">
                    {routes.map((route) => (
                        <Link
                            to={route.route}
                            key={route.navbar}
                            className={`topbar-nav-item ${route.align === 'end' ? 'align-end' : ''} ${window.location.href.includes(route.route) ? 'selected' : ''}`}
                        >
                            <span>{route.navbar.toUpperCase()}</span>
                            {route.warning && <img alt="exclamation" src={exclamation} className="topbar-exclamation-icon" />}
                        </Link>
                    ))}
                </div>
                <div className="topbar-menu-mobile" style={{ width: `${menuOpened ? 100 : 0}vw` }}>
                <div style={{ display: 'flex', flexDirection: 'column', height: '100%', justifyContent: 'space-between', padding: '50px 25px 92px 25px' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                            <img src={promo} alt="logo" className="logo-promo-mobile" />
                        {routes.slice(0, routes.length - 1).map((route) => (
                            <div
                                key={route.navbar}
                                onClick={() => navigate(route.route)}
                                className={window.location.href.includes(route.route) ? "topbar-menu-nav-item-selected" : "topbar-menu-nav-item"}
                            >
                                {window.location.href.includes(route.route) && <img src={arrow} className="topbar-menu-red-arrow-icon" alt="red-arrow-icon" />}
                                <p style={{ fontSize: '23px', fontWeight: '600', fontFamily: 'Poppins', whiteSpace: 'nowrap'}}>{route.navbar.toUpperCase()}</p>
                                {route.warning && <img alt="exclamation" src={exclamation} className="topbar-menu-exclamation-icon" />}
                            </div>
                        ))}
                    </div>
                    {!!currentUser && 
                        <div className="topbar-menu-bottom-container">
                            <div className="topbar-menu-nav-bottom" onClick={() => navigate(`/${currentPromo?.path}/perfil`)}>
                                <p>PERFIL</p>
                            </div>
                            <div className="topbar-menu-nav-bottom-logout" onClick={handleLogout}>
                                <p>SAIR</p>
                            </div>
                        </div>
                    }
                </div>
                </div>
            </>}
        </div>
    );
}

export default TopBar;
